import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const truckParamsSchema = object({
  truckId: stringToNumber()
})
